import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import "../assets/css/BoxButton.css";

const BoxButton = ({ open }) => {
  return (
    <Grid
      container
      className="bg-blue-dark"
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        py: "15px",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Button
          variant="contained"
          className="button-bg-purple"
          onClick={() => open(true)}
          sx={{
            width: "200px",
            height: "40px",
            border: "none",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            px: { xs: "10px", md: "30px" },
          }}
        >
          <Box
            className="icon-upload-report-button"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              mt: "-2px",
            }}
          />
          <Typography
            className="color-light"
            sx={{
              textTransform: "none",
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              fontWeight: 500,
              lineHeight: 1,
            }}
          >
            Carica report
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

export default BoxButton;
